'use client';

import { useEffect } from 'react';

interface BlogPreloaderProps {
  category?: string;
  page: number;
}

export default function BlogPreloader({ category, page }: BlogPreloaderProps) {
  useEffect(() => {
    // Add DNS prefetch and preconnect for Prismic CDN
    const addResourceHint = (
      rel: string,
      href: string,
      crossOrigin?: boolean,
    ) => {
      const existing = document.querySelector(
        `link[rel="${rel}"][href="${href}"]`,
      );
      if (!existing) {
        const link = document.createElement('link');
        link.rel = rel;
        link.href = href;
        if (crossOrigin) link.crossOrigin = '';
        document.head.appendChild(link);
      }
    };

    // Add connection optimizations
    addResourceHint('dns-prefetch', '//images.prismic.io');
    addResourceHint('preconnect', 'https://images.prismic.io', true);

    // Remove preloading since it's causing unused resource warnings
    // The priority prop on images is sufficient for LCP optimization
  }, [category, page]);

  return null; // This component only handles preloading
}
